import api from './_api';

const getConfig = () => api.get('/config');

const eventsService = {
  getConfig,
};

export default eventsService;
